module.exports = __webpack_public_path__ + "img/lg_ring_g_l_null_1.43e4c832.png";